module.exports = __webpack_public_path__ + "fonts/1d679c8.woff2";